import React, { useState, useContext } from "react";
import { getFromStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../constants/storageKeys";
interface LanguageContextType {
  language: string;
  changeLanguage: (lang: string) => void;
}
const LanguageContext = React.createContext<LanguageContextType>({
  language: "en",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  changeLanguage: () => {},
});
export const useLanguageContext = () => useContext(LanguageContext);
export default function LanguageContextProvider({
  children,
}: {
  children: any;
}) {
  const lang = getFromStorage(STORAGE_KEYS.language);
  const [language, changeLanguage] = useState(`${lang}` || "en");
  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
